import { PageRoute } from "../../../../models/enums";
import { removeProperties } from "../../../../services";


export const useHandleSearch = (props, state, queryParams, generateTags, runSearch = false) => {
  const handleSearch = () => {
    const { favoriteIds, module } = props;

    if (location.pathname.includes(PageRoute.user)) {
      return;
    }

    // Pages that only use the HOC for tags / url handling never search
    // (see the runSearch option of handleSearchPage).
    if (!favoriteIds || !runSearch) {
      state.current = { ...state.current, loading: false }
      return;
    }

    const submitData = {
      queryParams: queryParams.current,
      favoriteIds,
      // @ts-ignore
      module: module || queryParams.current.module
    };

    //check if the module in submit data is "korisnik" and if it is, undefined it
    if (submitData.module === PageRoute.user.split("/")[1]) {
      submitData.module = undefined;
    }

    props.searchAds(submitData, () => {
      state.current = { ...state.current, loading: false };
    });

    if (!submitData.module) {
      props.getFilteredCategories(
        removeProperties(queryParams.current, "category", "module")
      );
    }

    generateTags(props);
  };


  return handleSearch
}


// WEBPACK FOOTER //
// ./src/routes/Search/HOCs/hooks/useHandleSearch.ts